import React from 'react';
import Slider from 'react-slick';
import './carousel.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import cx from 'classix';

export interface CarouselImage {
  src: string;
  alt: string;
  title: string;
  instagramHandle: string;
  description: string;
  productLink: string;
  title2?: string;
  productLink2?: string;
}

type Styled = Pick<React.HTMLAttributes<any>, 'style' | 'className'>;

interface ImageCarouselProps extends Styled {
  images: CarouselImage[];
}

const MOBILE_BREAKPOINT = 768;
const MEDIUM_SCREEN_BREAKPOINT = 1200;

const ImageCarousel: React.FC<ImageCarouselProps> = ({ images, className }) => {
  const settings = {
    dots: true,
    infinite: true,
    slidesToShow: 2.5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: MOBILE_BREAKPOINT,
        settings: {
          slidesToShow: 1
        }
      },
      {
        breakpoint: MEDIUM_SCREEN_BREAKPOINT,
        settings: {
          slidesToShow: 1.5
        }
      }
    ]
  };

  return (
    <div className={cx('carousel-container', className)}>
      <Slider {...settings}>
        {images.map((image) => (
          <div key={image.src} className="carousel-slide">
            <img src={image.src} alt={image.alt} className="carousel-image"/>
            <div className="carousel-content">
              <h3 className="carousel-title">
                <a href={image.productLink} target="_blank" rel="noopener noreferrer">
                  {image.title}
                </a>
              </h3>
              {image.title2 && (
                <h3 className="carousel-title2">
                  <a href={image.productLink2} target="_blank" rel="noopener noreferrer">
                    {image.title2}
                  </a>
                </h3>
              )}
              <p className="carousel-instagram">{image.instagramHandle}</p>
              <p className="carousel-description">{image.description}</p>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default ImageCarousel;
